import React from "react";
import Layout from "../../Components/Layout/Layout";

const AdministrativeControls = () => {

  return (
    <Layout title="Administrative Controls" page="administrative-controls">
      Administrative controls
    </Layout>
  );
};

export default AdministrativeControls;
